(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50035,15805,92261,59654,55004,6050,12701,46599,54223,49105,59679],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 15805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96076);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18422);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89494);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);










var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionTitleContainer), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[type], className, titleStyle),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-title": true,
                    isBold: true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: titleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: titleSegments.length === 1 ? title : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                            "data-title": true,
                            isBold: true,
                            size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                            mobileSize: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                            variant: "span",
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            children: segment
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-subtitle": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        "data-description": true,
                        size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            secondTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_8__/* .TYPOGRAPHY_SIZE.headline24 */ .y3.headline24,
                    variant: secondTitleVariant,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-second-subtitle": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_7__["default"], {
                    "data-second-description": true,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    titleStyle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondTitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondSubtitle: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    titleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),
    secondTitleVariant: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (SectionTitle);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 50035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_BookCallIntro; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-calendly/dist/index.es.js



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/*\n  code is extracted from Calendly's embed stylesheet: https://assets.calendly.com/assets/external/widget.css\n*/\n\n.calendly-inline-widget,\n.calendly-inline-widget *,\n.calendly-badge-widget,\n.calendly-badge-widget *,\n.calendly-overlay,\n.calendly-overlay * {\n    font-size:16px;\n    line-height:1.2em\n}\n\n.calendly-inline-widget iframe,\n.calendly-badge-widget iframe,\n.calendly-overlay iframe {\n    display:inline;\n    width:100%;\n    height:100%\n}\n\n.calendly-popup-content {\n    position:relative\n}\n\n.calendly-popup-content.calendly-mobile {\n    -webkit-overflow-scrolling:touch;\n    overflow-y:auto\n}\n\n.calendly-overlay {\n    position:fixed;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    overflow:hidden;\n    z-index:9999;\n    background-color:#a5a5a5;\n    background-color:rgba(31,31,31,0.4)\n}\n\n.calendly-overlay .calendly-close-overlay {\n    position:absolute;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0\n}\n\n.calendly-overlay .calendly-popup {\n    box-sizing:border-box;\n    position:absolute;\n    top:50%;\n    left:50%;\n    -webkit-transform:translateY(-50%) translateX(-50%);\n    transform:translateY(-50%) translateX(-50%);\n    width:80%;\n    min-width:900px;\n    max-width:1000px;\n    height:90%;\n    max-height:680px\n}\n\n@media (max-width: 975px) {\n    .calendly-overlay .calendly-popup {\n        position:fixed;\n        top:50px;\n        left:0;\n        right:0;\n        bottom:0;\n        -webkit-transform:none;\n        transform:none;\n        width:100%;\n        height:auto;\n        min-width:0;\n        max-height:none\n    }\n}\n\n.calendly-overlay .calendly-popup .calendly-popup-content {\n    height:100%;\n}\n\n.calendly-overlay .calendly-popup-close {\n    position:absolute;\n    top:25px;\n    right:25px;\n    color:#fff;\n    width:19px;\n    height:19px;\n    cursor:pointer;\n    background:url(https://assets.calendly.com/assets/external/close-icon.svg) no-repeat;\n    background-size:contain\n}\n\n@media (max-width: 975px) {\n    .calendly-overlay .calendly-popup-close {\n        top:15px;\n        right:15px\n    }\n}\n\n.calendly-badge-widget {\n    position:fixed;\n    right:20px;\n    bottom:15px;\n    z-index:9998\n}\n\n.calendly-badge-widget .calendly-badge-content {\n    display:table-cell;\n    width:auto;\n    height:45px;\n    padding:0 30px;\n    border-radius:25px;\n    box-shadow:rgba(0,0,0,0.25) 0 2px 5px;\n    font-family:sans-serif;\n    text-align:center;\n    vertical-align:middle;\n    font-weight:bold;\n    font-size:14px;\n    color:#fff;\n    cursor:pointer\n}\n\n.calendly-badge-widget .calendly-badge-content.calendly-white {\n    color:#666a73\n}\n\n.calendly-badge-widget .calendly-badge-content span {\n    display:block;\n    font-size:12px\n}\n\n.calendly-spinner {\n    position:absolute;\n    top:50%;\n    left:0;\n    right:0;\n    -webkit-transform:translateY(-50%);\n    transform:translateY(-50%);\n    text-align:center;\n    z-index:-1\n}\n\n.calendly-spinner>div {\n    display:inline-block;\n    width:18px;\n    height:18px;\n    background-color:#e1e1e1;\n    border-radius:50%;\n    vertical-align:middle;\n    -webkit-animation:calendly-bouncedelay 1.4s infinite ease-in-out;\n    animation:calendly-bouncedelay 1.4s infinite ease-in-out;\n    -webkit-animation-fill-mode:both;\n    animation-fill-mode:both\n}\n\n.calendly-spinner .calendly-bounce1 {\n    -webkit-animation-delay:-0.32s;\n    animation-delay:-0.32s\n}\n\n.calendly-spinner .calendly-bounce2 {\n    -webkit-animation-delay:-0.16s;\n    animation-delay:-0.16s\n}\n\n@-webkit-keyframes calendly-bouncedelay {\n    0%,80%,100% {\n        -webkit-transform:scale(0);\n        transform:scale(0)\n    } \n    \n    40%{\n        -webkit-transform:scale(1);\n        transform:scale(1)\n    }\n}\n\n@keyframes calendly-bouncedelay{ \n    0%,80%,100% {\n        -webkit-transform:scale(0);\n        transform:scale(0)\n    }\n    \n    40% {\n        -webkit-transform:scale(1);\n        transform:scale(1)\n    }\n}";
styleInject(css);

function sanitizeColorString(str) {
    if (str.charAt(0) === "#") {
        return str.slice(1);
    }
    return str;
}
function sanitizePageSettingsProps(props) {
    if (props === null || props === void 0 ? void 0 : props.primaryColor) {
        props.primaryColor = sanitizeColorString(props.primaryColor);
    }
    if (props === null || props === void 0 ? void 0 : props.textColor) {
        props.textColor = sanitizeColorString(props.textColor);
    }
    if (props === null || props === void 0 ? void 0 : props.backgroundColor) {
        props.backgroundColor = sanitizeColorString(props.backgroundColor);
    }
    return props;
}

var CalendlyEvent;
(function (CalendlyEvent) {
    CalendlyEvent["PROFILE_PAGE_VIEWED"] = "calendly.profile_page_viewed";
    CalendlyEvent["EVENT_TYPE_VIEWED"] = "calendly.event_type_viewed";
    CalendlyEvent["DATE_AND_TIME_SELECTED"] = "calendly.date_and_time_selected";
    CalendlyEvent["EVENT_SCHEDULED"] = "calendly.event_scheduled";
})(CalendlyEvent || (CalendlyEvent = {}));
var formatCalendlyUrl = function (_a) {
    var url = _a.url, _b = _a.prefill, prefill = _b === void 0 ? {} : _b, _c = _a.pageSettings, pageSettings = _c === void 0 ? {} : _c, _d = _a.utm, utm = _d === void 0 ? {} : _d, embedType = _a.embedType;
    var sanitizedPageSettings = sanitizePageSettingsProps(pageSettings);
    var backgroundColor = sanitizedPageSettings.backgroundColor, hideEventTypeDetails = sanitizedPageSettings.hideEventTypeDetails, hideLandingPageDetails = sanitizedPageSettings.hideLandingPageDetails, primaryColor = sanitizedPageSettings.primaryColor, textColor = sanitizedPageSettings.textColor, hideGdprBanner = sanitizedPageSettings.hideGdprBanner;
    var customAnswers = prefill.customAnswers, date = prefill.date, email = prefill.email, firstName = prefill.firstName, guests = prefill.guests, lastName = prefill.lastName, location = prefill.location, name = prefill.name;
    var utmCampaign = utm.utmCampaign, utmContent = utm.utmContent, utmMedium = utm.utmMedium, utmSource = utm.utmSource, utmTerm = utm.utmTerm, salesforce_uuid = utm.salesforce_uuid;
    var queryStringIndex = url.indexOf("?");
    var hasQueryString = queryStringIndex > -1;
    var queryString = url.slice(queryStringIndex + 1);
    var baseUrl = hasQueryString ? url.slice(0, queryStringIndex) : url;
    var updatedQueryString = [
        hasQueryString ? queryString : null,
        backgroundColor ? "background_color=" + backgroundColor : null,
        hideEventTypeDetails ? "hide_event_type_details=1" : null,
        hideLandingPageDetails ? "hide_landing_page_details=1" : null,
        primaryColor ? "primary_color=" + primaryColor : null,
        textColor ? "text_color=" + textColor : null,
        hideGdprBanner ? "hide_gdpr_banner=1" : null,
        name ? "name=" + encodeURIComponent(name) : null,
        location ? "location=" + encodeURIComponent(location) : null,
        firstName ? "first_name=" + encodeURIComponent(firstName) : null,
        lastName ? "last_name=" + encodeURIComponent(lastName) : null,
        guests ? "guests=" + guests.map(encodeURIComponent).join(",") : null,
        email ? "email=" + encodeURIComponent(email) : null,
        date && date instanceof Date ? "date=" + formatDate(date) : null,
        utmCampaign ? "utm_campaign=" + encodeURIComponent(utmCampaign) : null,
        utmContent ? "utm_content=" + encodeURIComponent(utmContent) : null,
        utmMedium ? "utm_medium=" + encodeURIComponent(utmMedium) : null,
        utmSource ? "utm_source=" + encodeURIComponent(utmSource) : null,
        utmTerm ? "utm_term=" + encodeURIComponent(utmTerm) : null,
        salesforce_uuid
            ? "salesforce_uuid=" + encodeURIComponent(salesforce_uuid)
            : null,
        embedType ? "embed_type=" + embedType : null,
        /*
         * https://github.com/tcampb/react-calendly/pull/31
         * embed_domain must be defined to receive messages from the Calendly iframe.
         */
        "embed_domain=1",
    ]
        .concat(customAnswers ? formatCustomAnswers(customAnswers) : [])
        .filter(function (item) { return item !== null; })
        .join("&");
    return baseUrl + "?" + updatedQueryString;
};
var formatDate = function (d) {
    var month = d.getMonth() + 1;
    var day = d.getDate();
    var year = d.getFullYear();
    return [
        year,
        month < 10 ? "0" + month : month,
        day < 10 ? "0" + day : day,
    ].join("-");
};
var CUSTOM_ANSWER_PATTERN = /^a\d{1,2}$/;
var formatCustomAnswers = function (customAnswers) {
    var customAnswersFiltered = Object.keys(customAnswers).filter(function (key) {
        return key.match(CUSTOM_ANSWER_PATTERN);
    });
    if (!customAnswersFiltered.length)
        return [];
    return customAnswersFiltered.map(function (key) { return key + "=" + encodeURIComponent(customAnswers[key]); });
};

var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    function LoadingSpinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingSpinner.prototype.render = function () {
        return ((0,react.createElement)("div", { className: "calendly-spinner" },
            (0,react.createElement)("div", { className: "calendly-bounce1" }),
            (0,react.createElement)("div", { className: "calendly-bounce2" }),
            (0,react.createElement)("div", { className: "calendly-bounce3" })));
    };
    return LoadingSpinner;
}(react.Component));

var defaultStyles = {
    minWidth: "320px",
    height: "630px",
};
var InlineWidget = /** @class */ (function (_super) {
    __extends(InlineWidget, _super);
    function InlineWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: true,
        };
        _this.onLoad = _this.onLoad.bind(_this);
        return _this;
    }
    InlineWidget.prototype.onLoad = function () {
        this.setState({
            isLoading: false,
        });
    };
    InlineWidget.prototype.render = function () {
        var src = formatCalendlyUrl({
            url: this.props.url,
            pageSettings: this.props.pageSettings,
            prefill: this.props.prefill,
            utm: this.props.utm,
            embedType: "Inline",
        });
        return ((0,react.createElement)("div", { className: "calendly-inline-widget", style: this.props.styles || defaultStyles },
            this.state.isLoading && (0,react.createElement)(LoadingSpinner, null),
            (0,react.createElement)("iframe", { width: "100%", height: "100%", frameBorder: "0", title: this.props.iframeTitle || "Calendly Scheduling Page", onLoad: this.onLoad, src: src })));
    };
    return InlineWidget;
}(react.Component));

var ModalContent = /** @class */ (function (_super) {
    __extends(ModalContent, _super);
    function ModalContent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: true,
        };
        _this.onLoad = _this.onLoad.bind(_this);
        return _this;
    }
    ModalContent.prototype.onLoad = function () {
        this.setState({
            isLoading: false,
        });
    };
    ModalContent.prototype.render = function () {
        var src = formatCalendlyUrl({
            url: this.props.url,
            pageSettings: this.props.pageSettings,
            prefill: this.props.prefill,
            utm: this.props.utm,
            embedType: "PopupWidget",
        });
        return ((0,react.createElement)(react.Fragment, null,
            this.state.isLoading && (0,react.createElement)(LoadingSpinner, null),
            (0,react.createElement)("iframe", { width: "100%", height: "100%", frameBorder: "0", title: this.props.iframeTitle || "Calendly Scheduling Page", onLoad: this.onLoad, src: src })));
    };
    return ModalContent;
}(react.Component));

var Modal = (function (props) {
    if (!props.open)
        return null;
    if (!props.rootElement) {
        throw new Error('[react-calendly]: PopupModal rootElement property cannot be undefined');
    }
    return (0,react_dom.createPortal)((0,react.createElement)("div", { className: "calendly-overlay" },
        (0,react.createElement)("div", { onClick: props.onModalClose, className: "calendly-close-overlay" }),
        (0,react.createElement)("div", { className: "calendly-popup" },
            (0,react.createElement)("div", { className: "calendly-popup-content" },
                (0,react.createElement)(ModalContent, __assign({}, props)))),
        (0,react.createElement)("button", { className: "calendly-popup-close", onClick: props.onModalClose, "aria-label": "Close modal", style: {
                display: "block",
                border: "none",
                padding: 0,
            } })), props.rootElement);
});

var PopupButton = /** @class */ (function (_super) {
    __extends(PopupButton, _super);
    function PopupButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false,
        };
        _this.onClick = _this.onClick.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        return _this;
    }
    PopupButton.prototype.onClick = function (e) {
        e.preventDefault();
        this.setState({
            isOpen: true,
        });
    };
    PopupButton.prototype.onClose = function (e) {
        e.stopPropagation();
        this.setState({
            isOpen: false,
        });
    };
    PopupButton.prototype.render = function () {
        return ((0,react.createElement)(react.Fragment, null,
            (0,react.createElement)("button", { onClick: this.onClick, style: this.props.styles || {}, className: this.props.className || "" }, this.props.text),
            (0,react.createElement)(Modal, __assign({}, this.props, { open: this.state.isOpen, onModalClose: this.onClose, rootElement: this.props.rootElement }))));
    };
    return PopupButton;
}(react.Component));

var PopupWidget = /** @class */ (function (_super) {
    __extends(PopupWidget, _super);
    function PopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false,
        };
        _this.onClick = _this.onClick.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        return _this;
    }
    PopupWidget.prototype.onClick = function () {
        this.setState({
            isOpen: true,
        });
    };
    PopupWidget.prototype.onClose = function (e) {
        e.stopPropagation();
        this.setState({
            isOpen: false,
        });
    };
    PopupWidget.prototype.render = function () {
        return ((0,react.createElement)("div", { className: "calendly-badge-widget", onClick: this.onClick },
            (0,react.createElement)("div", { className: "calendly-badge-content", style: {
                    background: this.props.color || "#00a2ff",
                    color: this.props.textColor || "#ffffff",
                } },
                this.props.text || "Schedule time with me",
                this.props.branding && (0,react.createElement)("span", null, "powered by Calendly")),
            (0,react.createElement)(Modal, __assign({}, this.props, { open: this.state.isOpen, onModalClose: this.onClose, rootElement: this.props.rootElement }))));
    };
    return PopupWidget;
}(react.Component));

var EVENT_NAME = "message";
function useCalendlyEventListener(eventHandlers) {
    var _a = eventHandlers || {}, onDateAndTimeSelected = _a.onDateAndTimeSelected, onEventScheduled = _a.onEventScheduled, onEventTypeViewed = _a.onEventTypeViewed, onProfilePageViewed = _a.onProfilePageViewed;
    (0,react.useEffect)(function () {
        var onMessage = function (e) {
            var eventName = e.data.event;
            if (eventName === CalendlyEvent.DATE_AND_TIME_SELECTED) {
                onDateAndTimeSelected && onDateAndTimeSelected(e);
            }
            else if (eventName === CalendlyEvent.EVENT_SCHEDULED) {
                onEventScheduled && onEventScheduled(e);
            }
            else if (eventName === CalendlyEvent.EVENT_TYPE_VIEWED) {
                onEventTypeViewed && onEventTypeViewed(e);
            }
            else if (eventName === CalendlyEvent.PROFILE_PAGE_VIEWED) {
                onProfilePageViewed && onProfilePageViewed(e);
            }
        };
        window.addEventListener(EVENT_NAME, onMessage);
        return function cleanup() {
            window.removeEventListener(EVENT_NAME, onMessage);
        };
    }, [eventHandlers]);
}


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./components/Common/FullScreenEstimation/index.jsx
var FullScreenEstimation = __webpack_require__(92261);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/sections/BookCallIntro/BookCallIntro.module.scss
var BookCallIntro_module = __webpack_require__(39467);
var BookCallIntro_module_default = /*#__PURE__*/__webpack_require__.n(BookCallIntro_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/BookCallIntro/utils/index.js




function useProps(_param) {
    var section = _param.section, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "section"
    ]);
    var ref = (0,helper/* getDocumentFields */.OA)(section, [
        "images",
        "title",
        "subtitle",
        "contentModules", 
    ]), title = ref.title, subtitle = ref.subtitle, contentModules = ref.contentModules, images = ref.images;
    var ref1 = (0,helper/* getDocumentFields */.OA)(contentModules[1], [
        "url"
    ]), calendlyEventUrl = ref1.url;
    useCalendlyEventListener({
        onEventScheduled: function(e) {
            window.gtag("event", "book_call_from_videoask");
        }
    });
    return (0,_object_spread/* default */.Z)({
        title: title,
        subtitle: subtitle,
        contentModules: contentModules,
        calendlyEventUrl: calendlyEventUrl,
        widgetImage: images === null || images === void 0 ? void 0 : images[0]
    }, restProps);
}

;// CONCATENATED MODULE: ./UI/sections/BookCallIntro/index.jsx












var Media = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(34190)]).then(__webpack_require__.bind(__webpack_require__, 34190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34190)
            ];
        }
    }
});
function BookCallIntro(props) {
    var ref = useProps(props), introSection = ref.introSection, type = ref.type, title = ref.title, subtitle = ref.subtitle, calendlyEventUrl = ref.calendlyEventUrl, handleOnCTAClick = ref.handleOnCTAClick, widgetImage = ref.widgetImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ref: introSection,
        className: classnames_default()((BookCallIntro_module_default()).pageIntroSection, (BookCallIntro_module_default())[type]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (BookCallIntro_module_default()).contentWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BookCallIntro_module_default()).pageWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BookCallIntro_module_default()).pageTextContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                                    title: title,
                                    subtitle: subtitle,
                                    className: (BookCallIntro_module_default()).title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BookCallIntro_module_default()).actionWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                            path: calendlyEventUrl,
                                            className: (BookCallIntro_module_default()).linkButton,
                                            children: "Book a call"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                                            className: (BookCallIntro_module_default()).ctaButton,
                                            onClick: handleOnCTAClick,
                                            children: "Write a message"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BookCallIntro_module_default()).widgetContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (BookCallIntro_module_default()).widgetFrame,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineWidget, {
                                        url: calendlyEventUrl,
                                        pageSettings: {
                                            hideGdprBanner: true,
                                            hideEventTypeDetails: true,
                                            hideLandingPageDetails: true
                                        },
                                        styles: {
                                            width: "100%",
                                            height: "100%"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                                    asset: widgetImage,
                                    className: (BookCallIntro_module_default()).widgetImage
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                type: constants/* SVG_IMAGES_TYPES.arrowNarrowDown */.NL.arrowNarrowDown,
                className: (BookCallIntro_module_default()).arrow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenEstimation["default"], {})
        ]
    });
}
/* harmony default export */ var sections_BookCallIntro = (BookCallIntro);


/***/ }),

/***/ 92261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FullscreenEstimationContext": function() { return /* binding */ FullscreenEstimationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79897);
/* harmony import */ var UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59654);
/* harmony import */ var UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18422);
/* harmony import */ var UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56362);
/* harmony import */ var utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32522);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66723);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);










var FeedbackForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(84602), __webpack_require__.e(43919), __webpack_require__.e(49163), __webpack_require__.e(24908)]).then(__webpack_require__.bind(__webpack_require__, 49163));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49163)
            ];
        }
    },
    ssr: false
});
var FullScreenEstimation = function(param) {
    var isFullscreenEstimation = param.isFullscreenEstimation, closeFullscreenEstimation = param.closeFullscreenEstimation, extraDescription = param.extraDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_ModalWindow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isModalWindow: isFullscreenEstimation,
        closeModalWindow: closeFullscreenEstimation,
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullscreenEstimation),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().estimationContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.headline38 */ .y3.headline38,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    isBold: true,
                    children: "Got a project in mind?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UI_components_Typography__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    variant: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
                    size: UI_components_Typography_utils_useTypography__WEBPACK_IMPORTED_MODULE_6__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                    children: [
                        "Fill in this form or",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_LinkWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            path: "mailto:".concat(utils_constants_contacts__WEBPACK_IMPORTED_MODULE_8__/* .EMAIL_LINK */ .Vr),
                            children: "send us an e-mail"
                        })
                    ]
                }),
                isFullscreenEstimation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedbackForm, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().feedbackForm),
                    isBudgetSlider: true,
                    formKey: "estimation",
                    extraDescription: extraDescription,
                    withoutAdditionalInfo: true
                })
            ]
        })
    });
};
FullScreenEstimation.propTypes = {
    isFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool.isRequired),
    closeFullscreenEstimation: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().func.isRequired),
    extraDescription: (prop_types__WEBPACK_IMPORTED_MODULE_9___default().string)
};
var FullscreenEstimationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isShown: false,
    open: function() {
        return null;
    }
});
/* harmony default export */ __webpack_exports__["default"] = (FullScreenEstimation);


/***/ }),

/***/ 79897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86324);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);









var Svg = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ModalWindow = function(param) {
    var isModalWindow = param.isModalWindow, closeModalWindow = param.closeModalWindow, children = param.children, className = param.className;
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleOnClick = function(param) {
        var target = param.target;
        if (modalRef && modalRef.current) {
            if (modalRef.current.isEqualNode(target)) closeModalWindow();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .setOverflowForBody */ .zd)(isModalWindow);
    }, [
        isModalWindow
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleOnKeyDown = function(param) {
            var key = param.key;
            if (key === "Escape") {
                closeModalWindow();
            }
        };
        document.addEventListener("keydown", handleOnKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleOnKeyDown);
        };
    }, [
        closeModalWindow
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindowContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().show), isModalWindow)),
        onClick: handleOnClick,
        ref: modalRef,
        role: "dialog",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindow), className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().svg),
                    type: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SVG_IMAGES_TYPES.closeSvg */ .NL.closeSvg,
                    handleOnClick: closeModalWindow
                }),
                children
            ]
        })
    });
};
ModalWindow.defaultProps = {
    className: ""
};
ModalWindow.propTypes = {
    isModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool.isRequired),
    closeModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func.isRequired),
    children: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object).isRequired,
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalWindow);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 32522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ SOCIAL_MEDIA; },
/* harmony export */   "UE": function() { return /* binding */ PHONE_NUMBER; },
/* harmony export */   "Vr": function() { return /* binding */ EMAIL_LINK; },
/* harmony export */   "o4": function() { return /* binding */ ADDRESS; },
/* harmony export */   "zm": function() { return /* binding */ PLACEMENT_DATA; }
/* harmony export */ });

var EMAIL_LINK = "hi@yellow.systems";
var SOCIAL_MEDIA = {
    linkedin: {
        id: "linkedin",
        title: "LinkedIn",
        iconDark: "linkedinFilled",
        iconLight: "linkedinWhite",
        link: "https://www.linkedin.com/company/yellow-systems"
    },
    facebook: {
        id: "facebook",
        title: "Facebook",
        iconDark: "facebookDark",
        iconLight: "facebookWhite",
        link: "https://www.facebook.com/yellow.systems/"
    },
    twitter: {
        id: "twitter",
        title: "Twitter",
        iconDark: "twitterFilled",
        iconLight: "twitterWhite",
        link: "https://mobile.twitter.com/yellow_systems"
    },
    dribbble: {
        id: "dribbble",
        title: "Dribbble",
        iconDark: "dribbbleFilled",
        iconLight: "dribbbleWhite",
        link: "https://dribbble.com/yellow_systems"
    },
    behance: {
        id: "behance",
        title: "Behance",
        iconDark: "behanceFilled",
        iconLight: "behanceWhite",
        link: "https://www.behance.net/yellow_systems"
    },
    youtube: {
        id: "youtube",
        title: "YouTube",
        iconDark: "youtubeSocialFilled",
        iconLight: "youtubeWhite",
        link: "https://www.youtube.com/@yellowsystems9900"
    },
    instagram: {
        id: "instagram",
        title: "Instagram",
        iconDark: "instagramFilled",
        iconLight: "instagramWhite",
        link: "https://www.instagram.com/yellow.systems/"
    }
};
var PHONE_NUMBER = {
    us: "+1 (940) 601 6017"
};
var ADDRESS = {
    us: {
        addressCountry: "USA",
        addressLocality: "San Francisco",
        streetAddress: "44 Tehama St",
        postalCode: "94105"
    },
    ar: {
        addressCountry: "Argentina",
        addressLocality: "Buenos Aires",
        streetAddress: "Av. Corrientes 1312",
        postalCode: "C1043ABN"
    },
    pl: {
        addressCountry: "Poland",
        addressLocality: "Warszawa",
        streetAddress: "Grzybowska 62",
        postalCode: "00-855"
    },
    cy: {
        addressCountry: "Cyprus",
        addressLocality: "Larnaca",
        streetAddress: "Agias Faneromenis, 143, Flat 201",
        postalCode: "6031"
    }
};
var PLACEMENT_DATA = {
    USA: [
        "".concat(ADDRESS.us.streetAddress, " ").concat(ADDRESS.us.addressLocality, " ").concat(ADDRESS.us.postalCode), 
    ],
    Poland: [
        "".concat(ADDRESS.pl.addressLocality, " ").concat(ADDRESS.pl.postalCode),
        ADDRESS.pl.streetAddress, 
    ],
    Argentina: [
        "".concat(ADDRESS.ar.streetAddress, " ").concat(ADDRESS.ar.postalCode),
        ADDRESS.ar.addressLocality, 
    ]
};


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 39467:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageIntroSection":"BookCallIntro_pageIntroSection__BEDAk","arrow":"BookCallIntro_arrow__B1vt6","cedar-bounce":"BookCallIntro_cedar-bounce__kTKtT","contentWrapper":"BookCallIntro_contentWrapper__ErbTq","pageWrapper":"BookCallIntro_pageWrapper__drIlT","pageTextContainer":"BookCallIntro_pageTextContainer__iCxNh","title":"BookCallIntro_title__yziNe","widgetContainer":"BookCallIntro_widgetContainer___WQZi","widgetFrame":"BookCallIntro_widgetFrame___bto7","widgetImage":"BookCallIntro_widgetImage__A9fFj","actionWrapper":"BookCallIntro_actionWrapper__omk93","linkButton":"BookCallIntro_linkButton__yBckV","ctaButton":"BookCallIntro_ctaButton__wf8g6","blinking":"BookCallIntro_blinking__bCEzL","swing":"BookCallIntro_swing__wmsXL","animateborder":"BookCallIntro_animateborder__16gQk","animateborder-overlay":"BookCallIntro_animateborder-overlay__2h7dy","animatecircle":"BookCallIntro_animatecircle__RpIzK","animatedot":"BookCallIntro_animatedot__jlCI7","animStar":"BookCallIntro_animStar__ipldB","hideText":"BookCallIntro_hideText__SoU6Z","spin":"BookCallIntro_spin__LxNqh","outOfTransparencyDesktop":"BookCallIntro_outOfTransparencyDesktop__cLu95","outOfTransparencyMobile":"BookCallIntro_outOfTransparencyMobile__D2X_V","appearance":"BookCallIntro_appearance__oGUKy","appearanceFromBelow":"BookCallIntro_appearanceFromBelow__Ay0_w","flicker":"BookCallIntro_flicker__1YnVH","vibrate1":"BookCallIntro_vibrate1__nAVvI","rocket":"BookCallIntro_rocket__3nW6z","burgerItem1":"BookCallIntro_burgerItem1__2muW1","burgerItem2":"BookCallIntro_burgerItem2__T3g6q","burgerItem3":"BookCallIntro_burgerItem3__4SUOp","burgerItem1Reverse":"BookCallIntro_burgerItem1Reverse__36kY1","burgerItem2Reverse":"BookCallIntro_burgerItem2Reverse__NB1rX","burgerItem3Reverse":"BookCallIntro_burgerItem3Reverse__dGT4E","arrow-down":"BookCallIntro_arrow-down__dBC1W","image-scroll":"BookCallIntro_image-scroll__nuVvl","image-scroll-reverse":"BookCallIntro_image-scroll-reverse__F9uk7","stickerbox-pointer-move":"BookCallIntro_stickerbox-pointer-move__z_rsH","hide-image":"BookCallIntro_hide-image__kzmwD","stickerbox-pointer-second":"BookCallIntro_stickerbox-pointer-second__hTOdU","stickerbox-pointer-third":"BookCallIntro_stickerbox-pointer-third__gqe6p"};

/***/ }),

/***/ 66723:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreenEstimation":"styles_fullscreenEstimation__Rg_DE","estimationContainer":"styles_estimationContainer__gixM_","feedbackForm":"styles_feedbackForm__cR1Pq","title":"styles_title__07SXR","subtitle":"styles_subtitle__fjFtJ"};

/***/ }),

/***/ 86324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__ob2Fw","modalWindow":"styles_modalWindow__y6P7Y","svg":"styles_svg__i9wAY","show":"styles_show__3kdTG"};

/***/ })

}]);